import { Helmet } from "react-helmet"
import Header from "../components/Header"
import SideNav from "../components/SideNav"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import {
  createDollarWalletSettings,
  editDollarWalletSettings,
  fetchDollarWalletSettings,
  updateDollarWalletSettings
} from "../actions/dollarActions"
import Loader from "../components/Loader"
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit"
import { format, formatUSD } from "../main"

const DollarSettingsScreen = () => {
  const dispatch = useDispatch()
  const dollarRef = useRef(true)

  const [buy_conversion_rate, setBuyConversionRate] = useState(0)
  const [sell_conversion_rate, setSellConversionRate] = useState(0)
  const [minimum_funding, setMinimumFunding] = useState(0)
  const [maximum_funding, setMaximumFunding] = useState(0)
  const [buy_issuable_amount, setBuyIssuableAmount] = useState(0)
  const [sell_issuable_amount, setSellIssuableAmount] = useState(0)
  const [maximum_withdrawal, setMaximumWithdrawal] = useState(0)
  const [minimum_withdrawal, setMinimumWithdrawal] = useState(0)

  const [editMode, setEditMode] = useState(false)
  const [editId, setEditId] = useState(null)

  const getDollarWalletSettings = useSelector(
    (state) => state.getDollarWalletSettings
  )
  const { loading, success, settings, error } = getDollarWalletSettings

  const setDollarWalletSettings = useSelector(
    (state) => state.setDollarWalletSettings
  )
  const {
    loading: createLoading,
    success: createSuccess,
    error: createError,
    settings: createSettings
  } = setDollarWalletSettings

  const editDollarWalletSettingsState = useSelector(
    (state) => state.editDollarWalletSettings
  )
  const {
    loading: editLoading,
    success: editSuccess,
    error: editError,
    settings: editSettings
  } = editDollarWalletSettingsState

  useEffect(() => {
    if (dollarRef.current) {
      dispatch(fetchDollarWalletSettings())
      dollarRef.current = false
    }

    if (createSuccess || editSuccess) {
      window.location.reload()
    }
  }, [dispatch, createSuccess, editSuccess])

  const populateEditForm = (data) => {
    setEditMode(true)
    setEditId(data?.id)
    setBuyConversionRate(data?.buy_conversion_rate)
    setSellConversionRate(data?.sell_conversion_rate)
    setMinimumFunding(data?.minimum_funding)
    setMaximumFunding(data?.maximum_funding)
    setBuyIssuableAmount(data?.buy_issuable_amount)
    setSellIssuableAmount(data?.sell_issuable_amount)
    setMaximumWithdrawal(data?.maximum_withdrawal)
    setMinimumWithdrawal(data?.minimum_withdrawal)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const submitHandler = (e) => {
    e.preventDefault()

    const reqData = {
      buy_conversion_rate,
      sell_conversion_rate,
      minimum_funding,
      maximum_funding,
      buy_issuable_amount,
      sell_issuable_amount,
      maximum_withdrawal,
      minimum_withdrawal
    }

    if (editMode && editId) {
      console.log("here")
      dispatch(updateDollarWalletSettings(editId, reqData))
    } else {
      console.log("here o")
      dispatch(createDollarWalletSettings(reqData))
    }
  }

  return (
    <>
      <SideNav />
      <Helmet>
        <title>Customer | PennyTree - Dollar Settings</title>
      </Helmet>
      <section className="page-container">
        <div className="page-content">
          <Header />
          <div className="page-body">
            <h1>Dollar Settings &nbsp;(Today's Rate)</h1>
            {loading ? (
              <Loader />
            ) : error ? (
              <p className="text-danger text-center">{error}</p>
            ) : (
              <MDBTable responsive style={{ width: "100%", fontSize: "14px" }}>
                <MDBTableHead>
                  <tr>
                    <th>S/N</th>
                    <th>Date</th>
                    <th>Buy Conversion Rate</th>
                    <th>Sell Conversion Rate</th>
                    <th>Buy Issuable Amount</th>
                    <th>Sell Issuable Amount</th>
                    <th>Minimum Funding</th>
                    <th>Maximum Funding</th>
                    <th>Maximum Withdrawal</th>
                    <th>Minimum Withdrawal</th>
                    <th>Action</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {success && settings && (
                    <tr key={settings.data?.id}>
                      <td>1</td>
                      <td>{settings?.data?.date}</td>
                      <td>{format(settings?.data?.buy_conversion_rate)}</td>
                      <td>{format(settings?.data?.sell_conversion_rate)}</td>
                      <td>{formatUSD(settings?.data?.buy_issuable_amount)}</td>
                      <td>{formatUSD(settings?.data?.sell_issuable_amount)}</td>
                      <td>{formatUSD(settings?.data?.minimum_funding)}</td>
                      <td>{formatUSD(settings?.data?.maximum_funding)}</td>
                      <td>{formatUSD(settings?.data?.maximum_withdrawal)}</td>
                      <td>{formatUSD(settings?.data?.minimum_withdrawal)}</td>
                      <td>
                        <p
                          className="withdrawal-btn"
                          onClick={() => populateEditForm(settings?.data)}
                          style={{
                            cursor: "pointer",
                            color: "white",
                            width: "100px",
                            textAlign: "center"
                          }}
                        >
                          <span>Edit</span>
                        </p>
                      </td>
                    </tr>
                  )}
                </MDBTableBody>
              </MDBTable>
            )}

            <div>
              <br /> <br />
              <h4
                style={{
                  textAlign: "center",
                  background: editMode ? "#007bff" : "green",
                  padding: "7px",
                  textTransform: "capitalize",
                  letterSpacing: "0.7px"
                }}
              >
                {editMode
                  ? "Edit Dollar Wallet Settings"
                  : "Create Dollar Wallet Settings"}
              </h4>
              <div className="investment-form">
                <form onSubmit={submitHandler}>
                  <p className="text-danger text-center">
                    {editMode ? editError : createError}
                  </p>
                  <p className="text-success text-center">
                    {editMode
                      ? editSuccess && editSettings?.message
                      : createSuccess && createSettings?.message}
                  </p>

                  {/* Form Fields */}
                  <div className="form-group">
                    <label>Buy Conversion Rate:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={buy_conversion_rate}
                      onChange={(e) => setBuyConversionRate(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Sell Conversion Rate:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={sell_conversion_rate}
                      onChange={(e) => setSellConversionRate(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Minimum Funding:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={minimum_funding}
                      onChange={(e) => setMinimumFunding(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Maximum Funding:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={maximum_funding}
                      onChange={(e) => setMaximumFunding(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Buy Issuable Amount:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={buy_issuable_amount}
                      onChange={(e) => setBuyIssuableAmount(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Sell Issuable Amount:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={sell_issuable_amount}
                      onChange={(e) => setSellIssuableAmount(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Maximum Withdrawal:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={maximum_withdrawal}
                      onChange={(e) => setMaximumWithdrawal(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Minimum Withdrawal:</label>
                    <input
                      className="invest-input"
                      type="number"
                      value={minimum_withdrawal}
                      onChange={(e) => setMinimumWithdrawal(e.target.value)}
                    />
                  </div>

                  {editMode ? (
                    editLoading ? (
                      <Loader />
                    ) : (
                      <button type="submit" className="login-btn">
                        Update
                      </button>
                    )
                  ) : createLoading ? (
                    <Loader />
                  ) : (
                    <button type="submit" className="login-btn">
                      Publish
                    </button>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default DollarSettingsScreen
